import { Modal, Table, Button, Spin } from "antd";
import newStyled from "@emotion/styled";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useFetchFunction } from "../../utils/hooks/UseFetchUrl";
import { useEffect } from "react";
import { getScoreConfig } from "../../utils/hooks/useScoreScale1";

const AIObservationModal = ({
  open,
  selectedCycleId,
  title,
  auditStoreIds,
  onClose,
}) => {
  const { loading, data, getData } = useFetchFunction();
  const navigate = useNavigate();
  // console.log(auditStoreIds, "auditStoreIds in modal");

  useEffect(() => {
    if (!open || !selectedCycleId || !auditStoreIds?.length) return;

    const query = `audit_store_ids=${auditStoreIds.join(",")}`;
    getData(
      `audit_cycle/${selectedCycleId}/ai_insights_with_key_points?${query}`,
    );
  }, [open, selectedCycleId, auditStoreIds]);

  const responseData = Array.isArray(data)
    ? data
    : Array.isArray(data?.audit_stores)
      ? data.audit_stores
      : [];

  const dataSource = responseData.map((item, index) => ({
    key: item.audit_store_id || item.store_id || index,
    index: index + 1,
    ...item,
  }));

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "index",
      key: "Index",
      align: "center",
      width: "10%",
    },
    {
      title: "Store Name",
      dataIndex: "audit",
      align: "center",
      width: "25%",
      render: (audit) => {
        return audit?.store?.name || "";
      },
    },
    {
      title: "Marks",
      dataIndex: "audit_store_percentage",
      align: "center",
      width: "20%",
      render: (value) => {
        const percentage =
          typeof value === "object" ? value?.percentage : value;

        const scoreConfig = getScoreConfig(percentage);

        return (
          <div style={{ textAlign: "center", padding: 0 }}>
            <span
              className="rbScoreBadge"
              style={{
                backgroundColor: scoreConfig?.bgColor,
                color: scoreConfig?.color,
              }}
            >
              {percentage != null ? `${percentage}%` : "N/A"}
            </span>
          </div>
        );
      },
    },
    {
      title: "View Report",
      align: "center",
      width: "20%",
      render: (_, record) => {
        return (
          <BtnStyle
            style={{
              fontSize: "1rem",
              padding: "8px",
              backgroundColor: "#007dc1",
              color: "#fff",
            }}
            onClick={() => {
              window.open(
                `/auditReport/${record?.id}`,
                "_blank",
                "noopener,noreferrer",
              );
            }}
          >
            <EyeOutlined /> View
          </BtnStyle>
        );
      },
    },
  ];

  return (
    <ModalStl
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      styles={{
        body: {
          maxHeight: "75vh",
          overflowY: "auto",
        },
      }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <TableStyle
          dataSource={dataSource}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={false}
          bordered
          rowClassName={() => "custom-row"}
        />
      )}
    </ModalStl>
  );
};

const TableStyle = newStyled(Table)`
  .centered-column {
    text-align: center !important;
  }

  :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper table {
    width: 100%;
    text-align: start;
    border-radius: 8px 8px 0 0;
    border-spacing: 0;
  }

  :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper
    .ant-table-thead > tr > th,
  :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper
    .ant-table-tbody > tr > td {
    border: 1px solid #dde1e6 !important;
  }

  :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper
    .ant-table-thead > tr > th,
  :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper
    .ant-table-thead > tr > td {
    color: #000 !important;
    font-size: 1.1rem !important;
    font-family: "Roboto", sans-serif !important;
    background: rgb(242, 242, 242) !important;
  }
`;

const ModalStl = newStyled(Modal)`
  :where(.css-dev-only-do-not-override-1kf000u).ant-modal .ant-modal-title {
    color: #003C5D !important;
    font-size: 1.5rem !important;
    font-family: "Roboto", sans-serif !important;
  }
`;

const BtnStyle = newStyled(Button)`
  :where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-solid {
    background-color: #007dc1 !important;
  }
`;

export default AIObservationModal;
